import React, { useState } from "react";
import { Header, Text } from "@centrate-io/barn";

function CashFlows(props) {
    const loan = props?.loan;
    console.log(loan);
    
    return (
        <div className="crumbs" style={{padding: 32}}>
        <Header type="display" size="5">
            Cash Flows
        </Header>
        </div> 
    );
  }
  
  export default CashFlows;